(() => {
  const CONTROLLER_FLAG = 'data-hormonize-footer-js-ready';
  const DESKTOP_MEDIA_QUERY = '(min-width: 990px)';
  const FOOTER_SELECTOR = '.hormonize-footer';
  const ACCORDION_SELECTOR = '.hormonize-footer__accordion';

  const instances = new WeakMap();

  class HormonizeFooterAccordionState {
    constructor(footer) {
      this.footer = footer;
      this.mediaQuery = window.matchMedia(DESKTOP_MEDIA_QUERY);
      this.onMediaQueryChange = this.onMediaQueryChange.bind(this);
      this.mediaQuery.addEventListener('change', this.onMediaQueryChange);
      this.syncAccordionState();
    }

    getAccordions() {
      return this.footer.querySelectorAll(ACCORDION_SELECTOR);
    }

    syncAccordionState() {
      const accordions = this.getAccordions();
      const isDesktop = this.mediaQuery.matches;

      accordions.forEach((accordion) => {
        if (isDesktop) {
          accordion.setAttribute('open', '');
          return;
        }

        accordion.removeAttribute('open');
      });
    }

    onMediaQueryChange() {
      this.syncAccordionState();
    }

    destroy() {
      this.mediaQuery.removeEventListener('change', this.onMediaQueryChange);

      if (this.mediaQuery.matches) {
        this.getAccordions().forEach((accordion) => {
          accordion.removeAttribute('open');
        });
      }
    }
  }

  function initFooter(footer) {
    if (!(footer instanceof HTMLElement) || !footer.matches(FOOTER_SELECTOR)) {
      return;
    }

    if (instances.has(footer)) {
      return;
    }

    instances.set(footer, new HormonizeFooterAccordionState(footer));
  }

  function initFooters(root = document) {
    const searchRoot = root instanceof Element || root instanceof Document ? root : document;

    if (searchRoot instanceof Element && searchRoot.matches(FOOTER_SELECTOR)) {
      initFooter(searchRoot);
    }

    searchRoot.querySelectorAll(FOOTER_SELECTOR).forEach(initFooter);
  }

  function destroyFooters(root) {
    const searchRoot = root instanceof Element ? root : document;
    const footers = [];

    if (searchRoot instanceof Element && searchRoot.matches(FOOTER_SELECTOR)) {
      footers.push(searchRoot);
    }

    searchRoot.querySelectorAll(FOOTER_SELECTOR).forEach((footer) => {
      footers.push(footer);
    });

    footers.forEach((footer) => {
      const instance = instances.get(footer);

      if (!instance) {
        return;
      }

      instance.destroy();
      instances.delete(footer);
    });
  }

  function onSectionLoad(event) {
    initFooters(event.target);
  }

  function onSectionUnload(event) {
    destroyFooters(event.target);
  }

  function bindLifecycleEvents() {
    document.addEventListener('shopify:section:load', onSectionLoad);
    document.addEventListener('shopify:section:unload', onSectionUnload);
    document.addEventListener('shopify:section:reorder', () => {
      initFooters(document);
    });
  }

  if (!document.documentElement.hasAttribute(CONTROLLER_FLAG)) {
    document.documentElement.setAttribute(CONTROLLER_FLAG, '');
    bindLifecycleEvents();
  }

  initFooters(document);
})();
